import { useEffect, useState } from 'react';

/**
 * Tracks window.visualViewport so modals can sit above the mobile keyboard.
 */
export function useVisualViewport(active) {
  const [visibleViewport, setVisibleViewport] = useState(null);

  useEffect(() => {
    if (!active) {
      setVisibleViewport(null);
      return undefined;
    }

    const vv = window.visualViewport;
    if (!vv) return undefined;

    const syncViewport = () => {
      setVisibleViewport({
        top: vv.offsetTop,
        left: vv.offsetLeft,
        width: vv.width,
        height: vv.height,
      });
    };

    syncViewport();
    vv.addEventListener('resize', syncViewport);
    vv.addEventListener('scroll', syncViewport);

    return () => {
      vv.removeEventListener('resize', syncViewport);
      vv.removeEventListener('scroll', syncViewport);
    };
  }, [active]);

  const keyboardOpen = Boolean(
    visibleViewport && visibleViewport.height < window.innerHeight * 0.85
  );

  const shellStyle = visibleViewport
    ? {
        top: visibleViewport.top,
        left: visibleViewport.left,
        width: visibleViewport.width,
        height: visibleViewport.height,
      }
    : undefined;

  return { visibleViewport, keyboardOpen, shellStyle };
}

export function scrollFieldAboveKeyboard(element, scrollParent) {
  if (!element) return;
  window.requestAnimationFrame(() => {
    setTimeout(() => {
      const vv = window.visualViewport;
      const visibleBottom = (vv?.height ?? window.innerHeight) + (vv?.offsetTop ?? 0) - 16;
      const fieldRect = element.getBoundingClientRect();

      if (fieldRect.bottom > visibleBottom && scrollParent) {
        scrollParent.scrollTop += fieldRect.bottom - visibleBottom + 12;
      }
      element.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }, 320);
  });
}
